<template>
  <b-card class="m-3" no-body>
    <template #header>
      <div class="d-flex align-items-center justify-content-between ">
        <div></div>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Visualizar PDF
        </h6>
        <div>
          <b-button size="sm" title="Fazer download" @click="downloadPdf()" class="float-right mx-1 w-25"
            variant="secondary">
            <font-awesome-icon icon="file-download" />
          </b-button>
          <b-button size="sm" title="Próxima página" :disabled="page == numPages" @click="page++"
            class="float-right mx-1 w-25" variant="secondary">
            <font-awesome-icon icon="chevron-right" />
          </b-button>
          <b-button size="sm" title="Página anterior" :disabled="page == 1" @click="page--"
            class="float-right mx-1 w-25" variant="secondary">
            <font-awesome-icon icon="chevron-left" />
          </b-button>
          <span class="float-right m-1">Página {{ page }} de {{ numPages }} </span>
        </div>
      </div>
    </template>
    <div>
      <div>
        <div v-if="loadedRatio > 0 && loadedRatio < 1" style="background-color: green; color: white; text-align: center"
          :style="{ width: loadedRatio * 100 + '%' }">{{ Math.floor(loadedRatio * 100) }}%</div>
        <VuePdfEmbed
          ref="pdf"
          :source="data"
          :page-number="page"
          @rendered="onRendered"
          @loaded="onLoaded"
        />
      </div>
    </div>
  </b-card>
</template>

<script>
import { UtilsTS } from "@/utilsts"
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
export default {
  name: 'pdf-viewer',
  mixins: [UtilsTS],
  props: ['data', 'filename'],
  components: {
    VuePdfEmbed
  },
  data() {
    return {
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      rotate: 0,
    }
  },
  methods: {
    downloadPdf() {
      const agora = new Date();
      const timestamp = agora.getDate().toString().padStart(2, '0') +
        (agora.getMonth() + 1).toString().padStart(2, '0') +
        agora.getFullYear() +
        agora.getHours().toString().padStart(2, '0') +
        agora.getMinutes().toString().padStart(2, '0') +
        agora.getSeconds().toString().padStart(2, '0');
      if (this.data instanceof Uint8Array) {
        const blob = new Blob([this.data], { type: 'application/pdf' });
        this.download(`${this.filename}_${timestamp}.pdf`, blob);
      } else {
        this.downloadFromUrl(`${this.filename}_${timestamp}.pdf`, this.data);
      }
    },
    onLoaded(pdf) {
      this.numPages = pdf.numPages;
      this.loadedRatio = 1;
    },
    onRendered() {
      // Optionally handle after page render
    },
    //     agora.getHours().toString().padStart(2, '0') +
    //     agora.getMinutes().toString().padStart(2, '0') +
    //     agora.getSeconds().toString().padStart(2, '0')
    //   this.downloadFromUrl(`${this.filename}_${timestamp}.pdf`, this.data)
    // }
  }
}
</script>
